import AcceptTermsCheckbox from './AcceptTermsCheckbox';

export default AcceptTermsCheckbox;
